/**
 * Types for FileExplorer and related components.
 * Shared across @ncoder/ui and consumers (e.g. shell-web).
 */

export const TREE_INDENT = 16;
export const TREE_BASE_PADDING = 12;
export const getTreeItemPadding = (depth: number) => ({
  paddingLeft: `${depth * TREE_INDENT + TREE_BASE_PADDING}px`,
  paddingRight: `${TREE_BASE_PADDING}px`,
});

export interface FileNode {
  id: string;
  name: string;
  type: 'file' | 'folder';
  path: string;
  children?: FileNode[];
  content?: string;
  metadataType?: string;
  count?: number; // For folders - number of items
}

export type SyncState = 'idle' | 'syncing' | 'success' | 'error';

export interface SyncStatusBarProps {
  syncState: SyncState;
  syncProgress: number;
  syncMessage?: string;
  totalItems: number;
  processedItems: number;
  currentType?: string | null;
  lastSyncTime: Date | null;
  onSync: () => void;
  onCancel?: () => void;
  getRelativeTime: (date: Date | null) => string;
  disabled?: boolean;
}

export interface FileExplorerFilterConfig {
  onClick: () => void;
  activeCount?: number;
  totalCount?: number;
  shortcutLabel?: string;
  isActive?: boolean;
}

export interface FileExplorerSearchConfig {
  onClick: () => void;
  placeholder?: string;
  shortcutLabel?: string;
}
